import React, { useEffect, useState } from 'react';
import { PropsType } from 'src/app/components/DrawModule/draw-module-wrapper.config';
import DrawGroupModal from 'src/app/components/DrawGroupModal/DrawGroupModal';
import DrawPopup from 'src/app/components/DrawGroupModal/DrawPopup/DrawPopup';
import { DrawGeoFilterMap } from 'src/app/helpers/drawenLayer.helper';

import RotateModal from 'src/app/components/RotateModal/RotateModal';
import { useSelector } from 'react-redux';
import { reduxRootTypes } from 'src/types';

const DrawModuleWrapper = ({ drawController, drawGroups, setDrawGroups }: PropsType) => {
  const { hymotsDB } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);
  const { activeTabs } = useSelector((state: reduxRootTypes.RootStateType) => state.mapState);

  const [isActiveDrawGroupButton, setIsActiveDrawGroupButton] = useState<boolean>(false);
  const [activeLayerOnDraw, setActiveLayerOnDraw] = useState<any>();
  const [rotateData, setRotateData] = useState<any>();

  const tarafId = undefined;

  const onDrawLayerCreated = (layer: any) => {
    setActiveLayerOnDraw(layer);
  };
  useEffect(() => {
    if (drawController) {
      const drawGeoMapFilter: DrawGeoFilterMap = {
        tarafId,
        userRole: 'Controller',
      };

      if (hymotsDB && drawGeoMapFilter) {
        drawController.init(drawGeoMapFilter, onDrawLayerCreated, setRotateData, setDrawGroups);
      } else {
        drawController.destruct();
      }
    }

    return () => {
      if (drawController) {
        drawController.destruct();
      }
    };
  }, [drawController, hymotsDB]);

  useEffect(() => {
    if (drawController && hymotsDB) {
      drawController.setDrawGeoFilterMap(tarafId);
      drawController.createSocketConnection(hymotsDB, tarafId);
    }
  }, [drawController, tarafId, hymotsDB]);

  // Toggle draw group button state
  useEffect(() => {
    const domCustomDrawGroupPicker = document.querySelector('#customDrawGroupPicker') as HTMLButtonElement;

    if (domCustomDrawGroupPicker) {
      domCustomDrawGroupPicker.addEventListener('click', () => {
        setIsActiveDrawGroupButton((prevState) => !prevState);
      });
    }
  }, [drawController]);

  // Drawing tool styles logic
  useEffect(() => {
    const leafletDrawElement = document.querySelector('.leaflet-draw') as HTMLElement;
    const customColorPicker = document.querySelector('.custom-draw-color-picker') as HTMLElement;
    const drawGroupControl = document.querySelector('.draw-group-control') as HTMLElement;

    if (leafletDrawElement && customColorPicker) {
      if (activeTabs.editMode) {
        leafletDrawElement.style.display = 'block';
        customColorPicker.style.display = 'block';
        drawGroupControl.style.display = 'block';
      } else {
        leafletDrawElement.style.display = 'none';
        customColorPicker.style.display = 'none';
        drawGroupControl.style.display = 'none';
      }
    }
  }, [activeTabs.editMode]);

  useEffect(() => {
    if (drawController?.editMode) {
      setRotateData(undefined);
    } else {
      setRotateData(drawController?.rotateModalData);
    }
  }, [drawController?.rotateModalData, drawController?.editMode]);

  return (
    <>
      <DrawGroupModal
        active={isActiveDrawGroupButton}
        setActive={setIsActiveDrawGroupButton}
        tarafId={tarafId}
        drawController={drawController}
        drawGroups={drawGroups}
        setDrawGroups={setDrawGroups}
      />

      {activeLayerOnDraw && (
        <DrawPopup
          drawController={drawController}
          tarafId={tarafId}
          activeLayerOnDraw={activeLayerOnDraw}
          setActiveLayerOnDraw={setActiveLayerOnDraw}
          drawGroups={drawGroups}
          setDrawGroups={setDrawGroups}
          setRotateData={setRotateData}
        />
      )}

      {rotateData && !activeLayerOnDraw && !drawController?.editMode && (
        <RotateModal
          onClose={() => setRotateData(undefined)}
          feature={rotateData.feature}
          map={rotateData.map}
          drawController={drawController}
        />
      )}
    </>
  );
};

export default DrawModuleWrapper;
